import createUserModule from './user';
import createDeferredModule, { NAME as DEFERRED } from './deferred';
import { NAME as BASKET, createModule as createBasketModule } from '@/services';

const USER = 'user';

const MODULES = {
  USER,
  BASKET,
  DEFERRED,
};

const getModules = function (params) {
  const modules = {
    [USER]: createUserModule(params),
    [BASKET]: createBasketModule(params),
    [DEFERRED]: createDeferredModule(params),
  };
  return modules;
};

export { MODULES };

export default getModules;



// WEBPACK FOOTER //
// ./src/store/modules.js